import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "o-searchHeader__content"
}
const _hoisted_2 = { class: "o-searchHeader__formWrapper" }
const _hoisted_3 = ["data-t"]
const _hoisted_4 = { class: "m-input__wrapper" }
const _hoisted_5 = ["value", "placeholder"]
const _hoisted_6 = ["textContent"]
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "m-button__image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/assets/images/search.svg",
    width: "60",
    height: "60",
    alt: "",
    "aria-hidden": "true"
  })
], -1 /* HOISTED */)
const _hoisted_9 = ["textContent"]
const _hoisted_10 = {
  key: 0,
  class: "o-radios o-searchHeader__searchTypes"
}
const _hoisted_11 = {
  key: 0,
  class: "o-searchHeader__filtersButtonIndicator"
}
const _hoisted_12 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_icon = _resolveComponent("a-icon")!
  const _component_m_radio = _resolveComponent("m-radio")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "searchHeader",
    class: _normalizeClass(["o-searchHeader", { isSearchPage: $options.isSearchPage }])
  }, [
    _createVNode(_Transition, {
      name: "fade",
      mode: "out-in",
      onAfterEnter: $options.onAfterEnter,
      onBeforeLeave: $options.onBeforeLeave
    }, {
      default: _withCtx(() => [
        ($data.isActive || ($options.isSearchPage && !$data.overwriteActive))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("button", {
                type: "button",
                class: "o-searchHeader__closeButton",
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.onClick('close')))
              }, [
                _createVNode(_component_a_icon, { name: "close" })
              ]),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("form", {
                  "data-t": $props.texts.searchButton,
                  role: "search",
                  class: _normalizeClass(["o-searchHeader__form", 
                            !$options.isSearchPage ? 'o-searchHeader__form--simple' : ''
                        ]),
                  autocomplete: "off",
                  onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"])),
                  onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => ($options.onSubmit && $options.onSubmit(...args)), ["prevent"]))
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["m-input o-searchHeader__input", {
                                searchSimple: !$options.isSearchPage,
                                isFocused: $data.isFocused,
                                search: $options.isSearchPage,
                                nonSearchPage: !$options.isSearchPage,
                            }])
                  }, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("input", {
                        ref: "searchInput",
                        type: "text",
                        class: "a-input m-input__field",
                        value: $data.value,
                        placeholder: $options.placeholder,
                        onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($options.onBlur && $options.onBlur(...args))),
                        onFocus: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($options.onFocus && $options.onFocus(...args))),
                        onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($options.onInput && $options.onInput(...args)))
                      }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_5)
                    ]),
                    _createElementVNode("button", {
                      type: "submit",
                      role: "button",
                      tabindex: "0",
                      class: _normalizeClass(["m-input__button m-input__searchButton m-button--custom", { 'm-button': $options.isSearchPage }]),
                      onFocus: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($options.onSubmitButtonFocus && $options.onSubmitButtonFocus(...args))),
                      onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($options.onSubmitButtonBlur && $options.onSubmitButtonBlur(...args)))
                    }, [
                      _createVNode(_component_a_icon, {
                        name: "search",
                        class: "m-input__icon"
                      }),
                      ($options.isSearchPage)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "m-input__buttonText",
                            textContent: _toDisplayString(
                                        $options.isSearchPage && $options.currentSeachPage
                                            ? $options.currentSeachPage.name
                                            : $props.texts.searchButton
                                    )
                          }, null, 8 /* PROPS */, _hoisted_6))
                        : _createCommentVNode("v-if", true)
                    ], 34 /* CLASS, NEED_HYDRATION */)
                  ], 2 /* CLASS */),
                  _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                      (!$options.isSearchPage && $data.isFocused)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: `/${$props.searchUrl}`,
                            class: "m-button m-button--large m-button--shadowed o-searchHeader__suggestion",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => ($options.onClick('suggestion')))
                          }, [
                            _hoisted_8,
                            _createElementVNode("div", {
                              class: "m-button__text",
                              textContent: _toDisplayString($props.texts.suggestion)
                            }, null, 8 /* PROPS */, _hoisted_9)
                          ], 8 /* PROPS */, _hoisted_7))
                        : _createCommentVNode("v-if", true)
                    ], undefined, true),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                      (
                                    $options.isSearchPage && ($data.isFocused || $data.isTypeActive)
                                )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.searchPages, (searchPage, index) => {
                              return (_openBlock(), _createBlock(_component_m_radio, {
                                key: index,
                                modelValue: $data.radio,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($data.radio) = $event)),
                                class: "o-radios__radio",
                                label: searchPage.name,
                                value: searchPage.url
                              }, null, 8 /* PROPS */, ["modelValue", "label", "value"]))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]))
                        : _createCommentVNode("v-if", true)
                    ], undefined, true),
                    _: 1 /* STABLE */
                  })
                ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_3),
                (!$data.isFocused && $options.hasTags)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "o-searchHeader__reset",
                      "aria-label": "Reset",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => ($options.onClick('removeQuery')))
                    }, [
                      _createVNode(_component_a_icon, {
                        class: "m-button__icon",
                        name: "close_small"
                      })
                    ]))
                  : _createCommentVNode("v-if", true),
                ($options.isSearchPage)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      class: _normalizeClass(["m-button o-searchHeader__searchType", { active: $data.isTypeActive || $data.isFocused }]),
                      onClick: _cache[11] || (_cache[11] = ($event: any) => ($options.onClick('searchType')))
                    }, [
                      _createVNode(_component_a_icon, {
                        class: "m-button__icon o-searchHeader__searchTypeIcon",
                        name: "arrow_drop_down"
                      })
                    ], 2 /* CLASS */))
                  : _createCommentVNode("v-if", true)
              ]),
              ($options.showFilters)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "o-searchHeader__filtersButton",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => ($options.onClick('filters')))
                  }, [
                    _createVNode(_component_a_icon, { name: "tune" }),
                    _createVNode(_Transition, { name: "fade" }, {
                      default: _withCtx(() => [
                        ($options.hasFilters)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_11))
                          : _createCommentVNode("v-if", true)
                      ], undefined, true),
                      _: 1 /* STABLE */
                    })
                  ]))
                : _createCommentVNode("v-if", true)
            ]))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              class: "m-button m-button m-button--custom o-searchHeader__searchButton",
              "aria-label": "Søg bolig",
              onClick: _cache[13] || (_cache[13] = ($event: any) => ($options.onClick('open')))
            }, [
              _createElementVNode("span", {
                class: "m-button__text o-searchHeader__searchButtonText",
                textContent: _toDisplayString($props.texts.searchButton)
              }, null, 8 /* PROPS */, _hoisted_12),
              _createVNode(_component_a_icon, {
                class: "m-button__icon o-searchHeader__searchButtonIcon",
                name: "search"
              })
            ]))
      ], undefined, true),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["onAfterEnter", "onBeforeLeave"])
  ], 2 /* CLASS */))
}